// İşlem Ayrıntıları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.transactionDetail';

export const accountTransactionDetailGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'İşlem Ayrıntıları nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu pencere seçtiğiniz tek bir hareketin kimlik, tutar, işlem türü, hesap ve belge bilgilerini tek yerde gösterir. Kaydı silmeden, düzeltmeden veya rapora almadan önce hızlıca kontrol etmenizi sağlar.'),
  regionLabels: {
    body: t(`${G}.regions.body`, 'İşlem bilgileri'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Doğru carideki işlem mi?'),
      text: t(`${G}.s1.text`, 'Cari Hesap ID ve Cari Hesap Adı, hareketin doğru hesaba işlendiğini kontrol etmenizi sağlar.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. İşlemin türüne bakın'),
      text: t(`${G}.s2.text`, 'İşlem türü ve operasyon türü hareketin finansal sınıfını gösterir (ör. satış faturası, tahsilat, ödeme). İşlem Yönü etiketi hareketin Gelir mi Gider mi olduğunu söyler.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Tutarın bakiyeye etkisini görün'),
      text: t(`${G}.s3.text`, 'Tutar, Borç ve Alacak alanları hareketin bakiyeyi nasıl etkilediğini netleştirir. Varsa Önceki Bakiye ve Sonraki Bakiye işlemden önceki ve sonraki durumu gösterir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Belge ve tarih bilgilerini kontrol edin'),
      text: t(`${G}.s4.text`, 'Belge no, ödeme yöntemi, kasa / banka hesabı ve tarih, muhasebe doğrulaması ve denetim izi için temel referanstır. Oluşturan ve oluşturulma tarihi kaydı kimin, ne zaman girdiğini gösterir.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Ne zaman kullanmalı?'),
      text: t(`${G}.s5.text`, 'Tutar uyuşmazlığı, yanlış işlem türü şüphesi veya belge karşılaştırması gereken durumlarda bu ekranı esas alarak hızlı ve tutarlı karar verin. İşiniz bitince Kapat\'a basın.'),
    },
  ],
});
